import { useHistory } from "react-router";
import { useURLStore } from "./stateManagement/URLZustand";
import { useGlobalStore } from "./stateManagement/globalZustand";
import { IonBreadcrumb, IonBreadcrumbs, IonIcon } from "@ionic/react";
import { _libName, _rootName } from "./constants";
import { home, library } from "ionicons/icons";
import { label2LabelToShow } from "../foo/cards";
import './Breadcrumbs.css';

interface PathObject {
    path: string;
    pathSeparator: string;
  }
  
  export const Breadcrumbs = ({ path, pathSeparator } : PathObject) => {
    const { getURLTo } = useURLStore();
    const { lang } = useGlobalStore();
    const history = useHistory();
    // If path is empty, return null
    if (!path) return null;
  
  
    // Split the path by the pathSeparator into an array
    const breadcrumbs = path.split(pathSeparator);
  
  
    return (
      <IonBreadcrumbs>
        {breadcrumbs.map((breadcrumb, index) => (
          <IonBreadcrumb 
            className="bpart"
            key={index+breadcrumb}          
            onClick={() => {history.push(getURLTo().talkFromCustomNodePath(breadcrumbs.slice(0, index + 1).join(pathSeparator)))}}>
            {breadcrumb === _rootName ? <IonIcon icon={home} /> : breadcrumb === _libName ? <IonIcon icon={library} /> : label2LabelToShow(breadcrumb, lang, 1)}
          </IonBreadcrumb>
        ))}
      </IonBreadcrumbs>
    );
  };